module.exports = __webpack_public_path__ + "static/expresscv_background-b650d4592b3cfa3da15bae1196ebc97a.svg";